/* WASTELAND STORE banner — full-bleed 2in-tall supply route strip pinned under the
   reader preview. Bold digital broadcast treatment: scrolling glyph ticker, scan
   sweep, RGB-split headline. Taps open the store popup via the header's global hook. */
import { ShoppingBag } from "lucide-react";

const TICKER = "PRE-ORDER DOLO VOL. 1 /// DROPS DECEMBER 01 /// SHOP THE WASTELAND STORE TO GET YOUR DOLO MERCH /// OFFICIAL SUPPLY ROUTE OPEN /// IGOTISM.COM /// ";

export function StoreBanner() {
  return (
    <section className="store-banner" data-testid="store-banner-section">
      <button
        type="button"
        className="store-banner-hit"
        onClick={() => window.__openStore?.()}
        data-testid="store-banner"
        aria-label="Shop the wasteland store — opens official store links"
      >
        <span className="store-banner-scan" aria-hidden="true" />
        <span className="store-banner-ticker" aria-hidden="true">
          <span>{TICKER.repeat(2)}</span>
          <span>{TICKER.repeat(2)}</span>
        </span>
        <span className="store-banner-core">
          <span className="store-banner-eyebrow">PRE-ORDER PERIOD OPEN // OFFICIAL OUTFITTER</span>
          <strong className="store-banner-line" data-testid="store-banner-headline">
            <span className="sb-g sb-red" aria-hidden="true">SHOP THE WASTELAND STORE</span>
            SHOP THE WASTELAND STORE
            <span className="sb-g sb-cyan" aria-hidden="true">SHOP THE WASTELAND STORE</span>
          </strong>
          <span className="store-banner-sub">VOL. 1 PRE-ORDERS OPEN — <em>DROPS DEC 01</em></span>
        </span>
        <span className="store-banner-cta" data-testid="store-banner-cta">
          <ShoppingBag size={15} /> SHOP NOW
        </span>
      </button>
    </section>
  );
}
